export default __webpack_public_path__ + "static/media/dieppe13.6191c23a.jpg";